<router-outlet></router-outlet>
<div id="live-region" aria-live="assertive" class="sr-only"></div>
<div class="loader" id="loader1">
  <img id="loader_1" src="/assets/images/loader.gif"
          alt="loader1">
</div>


<script>
  document.addEventListener("DOMContentLoaded", function () {
    var acc = document.querySelectorAll(".aba-accordion");
    acc.forEach(function (button) {
      button.addEventListener("click", function () {
        // Close all other panels
        acc.forEach(function (otherButton) {
          if (otherButton !== button) {
            otherButton.classList.remove("active");
            var otherPanel = otherButton.nextElementSibling;
            otherPanel.style.maxHeight = null;
            otherPanel.classList.remove("show");
          }
        });

        // Toggle the clicked panel
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
          panel.classList.remove("show");
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          panel.classList.add("show");
        }
      });
    });
  });
</script>

<a data-bs-toggle="modal" data-bs-target="#myLogoutModel" id="logoutopen" aria-label="Bankexec" role="button"></a>
<div class="modal" id="myLogoutModel" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
  <div class="modal-content">
    <div class="modal-main-content">
      <h2 class="modal-heading center">Account Locked</h2>
      <p class="modal-heading center">
        Your account has been locked.Please click the button below to return
        to the login screen.
        <br />
      </p>
      <div class="button-container button-container-center">
        <button type="button" (click)="logout()" class="modal-button yes-button" data-bs-dismiss="modal">
          Return to Login Page
        </button>
      </div>
    </div>
  </div>
</div>

<a data-bs-toggle="modal" data-bs-target="#AccountLockModel" id="logout_popup"
  aria-label="Bankexec" role="button"></a>
<div class="modal" id="AccountLockModel" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
  <div class="modal-dialog">
  <div class="modal-content modal-content-40">
    <div class="modal-main-content">
      <h2 class="modal-heading center" tabindex="0">Account Locked</h2>
      <p class="modal-heading center" tabindex="0">
        Your Action Plan has been submitted for final plan. You will now be
        logged out and will not be able to log back in until your Instructor
        opens the next quarter.
        <br />
      </p>
      <div class="button-container button-container-center">
        <button type="button" (click)="logout()" class="modal-button yes-button" data-bs-dismiss="modal">
          OK
        </button>
      </div>
    </div>
  </div>
  </div>
</div>